<template>
  <div></div>
</template>

<script>
/**
 * マップ上にプライベートプロットを表示するコンポーネント
 * @parent O.MapViewGridItem, LiveMap
 * @props isReady: Boolean マップ情報が描画されているかのフラグ
 * @props map: Object １マップ分のインスタンスデータ
 * @props filterPrivatePlots: Array プロットの表示を制限するためのデータ、グリッドマップからはローカルDBライブマップからはFirestoreのデータが送られる。
 */
import {
  PrivatePlotMapLayer,
  PrivatePlotMapSource,
  LayersHigherClickPriorityThanPlot,
} from "@/config/Map.js";
import { createNamespacedHelpers } from "vuex";
// Store
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

const { mapState: mapStateOfPrivatePlot } =
  createNamespacedHelpers("gkmgPrivatePlot");

export default {
  name: "O.PrivatePlotLayer",
  data() {
    return {
      initialized: false,
      storeUnsubscribe: null,
    };
  },
  props: {
    map: Object,
    isReady: { type: Boolean, default: false },
    filterPrivatePlots: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapStateOfPrivatePlot({
      privatePlots: (state) => state.privatePlots,
    }),
  },
  watch: {
    isReady() {
      if (this.isReady) {
        this.isMapReady();
        let filters = ["in", "category"].concat(this.filterPrivatePlots);
        this.filterByPlotCategories(filters);
      }
      if (!this.initialized) {
        this.initialized = true;
      }
    },
    filterPrivatePlots: {
      handler(val) {
        let filters = ["in", "category"].concat(val);
        this.filterByPlotCategories(filters);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["cleanUpVesselDetail", "showPrivatePlotDetail"]),
    bindLayerClick() {
      Object.values(PrivatePlotMapLayer).forEach((layer) => {
        this.map.on("click", layer.id, (e) => {
          // クリックした場所に存在するfeatureを取得
          const features = this.map.queryRenderedFeatures(e.point, {
            layers: LayersHigherClickPriorityThanPlot,
          });
          // クリックした場所に船舶関連のfeatureが含まれていたら何もしない
          if (features.length > 0) {
            return;
          }
          const target = this.privatePlots.find(
            (plot) => plot.hash === e.features[0].properties.hash,
          );
          this.cleanUpVesselDetail();
          this.showPrivatePlotDetail(target);
        });
      });
    },
    /** レイヤーの描画処理 */
    isMapReady() {
      if (!this.initialized) {
        this.bindLayerClick();
        this.setPointerStyle();
      }

      this.map.addLayer({
        id: PrivatePlotMapLayer.PrivatePlotTextLayer.id,
        type: "symbol",
        source: PrivatePlotMapSource.PrivatePlotPointSource.id,
        minzoom: 8,
        maxzoom: 19,
        layout: {
          "text-field": "{title}",
          "text-anchor": "top",
          "text-size": 14,
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });

      this.map.addLayer({
        id: PrivatePlotMapLayer.PrivatePlotSymbolLayer.id,
        type: "symbol",
        source: PrivatePlotMapSource.PrivatePlotPointSource.id,
        minzoom: 8,
        maxzoom: 19,
        layout: {
          "icon-ignore-placement": true,
          "icon-allow-overlap": true,
          "icon-optional": true,
          "icon-anchor": "bottom",
          "icon-image": "{icon}",
        },
        paint: {},
      });

      this.map.addLayer({
        id: PrivatePlotMapLayer.PrivatePlotPolygonLayer.id,
        type: "fill",
        source: PrivatePlotMapSource.PrivatePlotPolygonSource.id,
        minzoom: 8,
        maxzoom: 19,
        paint: {
          "fill-color": {
            type: "identity",
            property: "color",
          },
          "fill-opacity": 0.7,
        },
      });

      this.map.addLayer({
        id: PrivatePlotMapLayer.PrivatePlotPolygonTextLayer.id,
        type: "symbol",
        source: PrivatePlotMapSource.PrivatePlotPolygonSource.id,
        minzoom: 8,
        maxzoom: 19,
        layout: {
          "text-field": "{title}",
          "text-anchor": "top",
          "text-size": 14,
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });
    },
    /** filterを実行する */
    filterByPlotCategories(filters) {
      if (!this.map) return;
      Object.values(PrivatePlotMapLayer).forEach((layer) => {
        if (this.map.getLayer(layer.id)) {
          this.map.setFilter(layer.id, filters);
        }
      });
    },
    setPointerStyle() {
      Object.values(PrivatePlotMapLayer).forEach((layer) => {
        let self = this;
        this.map.on("mousemove", layer.id, () => {
          self.setCursor(true, self);
        });
        this.map.on("mouseleave", layer.id, () => {
          self.setCursor(false, self);
        });
      });
    },
    setCursor(isPointer, self) {
      self.map.getCanvas().style.cursor = isPointer ? "pointer" : "";
    },
  },
};
</script>

<style scoped></style>
